import { Injectable } from '@angular/core';

import { UtilFunctions } from './pipes.module/_util.functions';
import { environment } from '../environments/environment';

@Injectable()
export class AppConstants {

    /* nur als Fallback verwenden, wenn z.B. die Url-Ermittlung nicht funktioniert */
    readonly kreditportalUrl = 'https://kreditportal.vhv.de';

    readonly baseHref = environment.baseHref;

    readonly loginUrl = 'login';

    thisYear: number = UtilFunctions.getRecentYear();

    static readonly VHV_PASSWORD_ERROR_MSG = 'Das eingegebene Passwort ist nicht zulässig und muss den genannten Regeln entsprechen.';

    static readonly VHV_PASSWORD_NOT_ALLOWED_MSG = 'Das eingegebene Passwort ist nicht zulässig.';

    static readonly VHV_BENUTZER_ID_MSG = 'Die eingegebene Benutzer-ID ist nicht korrekt. Sie finden die Benutzer-ID ' +
        'in der E-Mail "Bestätigung Mail-Adresse".';

    static readonly LOGIN_ERROR_MSG = 'Bitte überprüfen Sie Ihren Benutzernamen und Passwort. Sollten Sie ihr Passwort ' +
        'vergessen oder zu häufig falsch eingegeben haben, verwenden Sie bitte die Funktion „Zugangsdaten vergessen?“.';

    static readonly VHV_EMAIL_REGEX = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,64})$/;

    static readonly VHV_EMAIL_MAXLEN = 50;

    static readonly VHV_UPLOAD_FILENAME_REGEX = /^[a-zA-Z0-9 .\-_]+$/;

    static readonly VHV_UPLOAD_FILENAME_MSG = 'Die hochgeladenen Dateien dürfen nur Buchstaben, Ziffern, Punkt, ' +
        'Bindestrich, Unterstrich und Leerzeichen enthalten.';

    readonly VERTRAG_AUSLASTUNG_WARNING_OVER = 80;

    /* Datum, ab welchem ein neues Jahr angezeigt wird */
    readonly thresholdForNextYear = [8, 30]; // month (-1), day -> 30. September

    /* Erwartete Lebenszeit eines Tokens. Steht auch im Token, dieses hier ist quasi ein Dummy. */
    readonly tokenValidMillis: number = 1000 * 60 * 20; // 20 Minuten

    readonly bsAntragMaxFileSumSize: number = 1024 * 1024 * 3; // 3 MB

    readonly jahresAbschlussMaxFileSumSize: number = 1024 * 1024 * 20; // 20 MB

    readonly pagerDefaultNumPerPage: number = 12;

    /* Common messages */
    readonly messages = {
        fehlerAufgetreten: 'Es ist ein Fehler aufgetreten',
        spaeterErneutVersuchen: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
        uploadFileEmpty: 'Die Datei "$fileName" enthält keine Daten.',
        uploadFileToLarge: 'Die Datei "$fileName" ist zu groß ($fileSize MB). Max. zulässige Dateigröße: $max MB.',
        uploadFilesToMany: '$numFilesRequest Dateien überschreiten das Limit. Sie können nur bis zu $numFiles Datei(en) hochladen.',
        uploadFilesWrongType: 'Entschuldigung. Wir konnten die Datei $fileName nicht verarbeiten.',
        uploadFileSumTooLarge: 'Zulässige Gesamtgröße aller Dateien: max. $max MB. (Ihre Dateien: $fileSize MB)',
        jahresabschlussFileTypeMsg: 'Zulässige Dateiformate: *.xbrl, *.xml, *.pdf, *.doc, *.docx, *.odt, *.rtf, *.xls, *.xlsx, *.ods, *.txt',
        bgAntragFremdformulareFileTypeMsg: 'Zulässige Dateiformate: *.pdf, *.doc, *.docx, *.txt, *.rtf, *.xls, *.xlsx, *.bmp, *.png, *.jpg, *.gif, *.tif, *.tiff, *.ppt',
        registrationZugangsdatenNichtkorrekt: 'Die eingegebenen Zugangsdaten zur Verifizierung sind nicht korrekt.',
        registrationErrorSachbearbeiter: 'Eine Verifizierung der Zugangsdaten ist nicht möglich. Wenden Sie sich an Ihren Sachbearbeiter.',
        loginErrorMessage: AppConstants.LOGIN_ERROR_MSG,
        partnerAenderungDetails1: 'Die Änderung wird in den nächsten Tagen durchgeführt.',
        partnerAenderungDetails2: 'Erst dann ist die Änderung im Kreditportal sichtbar.',
        partnerAenderungSuccess: 'Übermittlung erfolgreich.',
        userAnlegenDetails: 'Der neu angelegte Benutzer erhält in Kürze eine E-Mail zur Vergabe eines neuen Passworts.',
        noMessages: 'Sie haben keine aktuellen Meldungen.',
        vhvWrongPassword: AppConstants.VHV_PASSWORD_ERROR_MSG,
        maxObligoExtended: 'Die maximale Anzahl von Obligolisten wurde heute bereits abgerufen. Die Funktion steht Ihnen morgen wieder zur Verfügung.',
        registrationCheckNotFound: 'Die eingegebenen Registrierungsdaten sind ungültig. Haben Sie sich eventuell vertippt? Möglicherweise wurde die Registrierung bereits abgeschlossen. In diesem Fall können Sie sich auf der Login-Seite mit Ihren Zugangsdaten anmelden.',
        registrationVerifyNotFound: 'Die eingegebenen Registrierungsdaten sind ungültig. Möglicherweise wurde die Registrierung bereits abgeschlossen. In diesem Fall können Sie sich auf der Login-Seite mit Ihren Zugangsdaten anmelden.',
        registrationVerifyUserNotFound: 'Es ist kein offener Vorgang zur Aktivierung Ihres Nutzer-Accounts vorhanden. Sie können sich mit Ihren Zugangsdaten anmelden.',
        passwortResetTokenNotValid: 'Der Link zur Vergabe eines neuen Passwortes ist nicht mehr gültig. Verwenden Sie die Funktion "Zugangsdaten vergessen" erneut, um eine neue E-Mail mit einem neuen Link zu erhalten.',
        passwortResetLocked: 'Die Funktion "Zugangsdaten vergessen" wurde aus Sicherheitsgründen gesperrt, da zu viele Passwortwiederherstellungen angefordert wurden. Bitte prüfen Sie, ob Sie unter der hinterlegten E-Mail-Adresse eine entsprechende E-Mail erhalten haben. Sollten Sie kein neues Passwort mehr vergeben können, wenden Sie sich bitte an Ihren Sachbearbeiter.',
    };

    readonly jahresabschlussFilter = [
        '.xbrl',
        '.xml',
        '.pdf',
        '.doc',
        '.docx',
        '.odt',
        '.rtf',
        '.xls',
        '.xlsx',
        '.ods',
        '.txt'
    ];

    readonly bgschCreateFileFilter = [
        '.bmp',
        '.png',
        '.jpg',
        '.gif',
        '.tif',
        '.tiff',
        '.ppt',
        '.pdf',
        '.doc',
        '.docx',
        '.rtf',
        '.xls',
        '.xlsx',
        '.txt'
    ];

    readonly httpErrorMessages = {
        '_500': {
            headline: this.messages.fehlerAufgetreten,
            details: ['Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'],
        },
        '_400': {
            headline: this.messages.fehlerAufgetreten,
            details: ['Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'],
        },
        '_401': {
            headline: this.messages.fehlerAufgetreten,
            details: ['Sie haben keine Berechtigung.', 'Möglicherweise ist Ihre Sitzung abgelaufen.'],
        },
        '_404': {
            headline: this.messages.fehlerAufgetreten,
            details: [],
        },
        '_406': {
            headline: this.messages.fehlerAufgetreten,
            details: ['Wir akzeptieren diese Anfrage aufgrund hier angegebener Regeln nicht.'],
        },
        '_423': {
            headline: 'Ihr Account wurde gesperrt.',
            details: ['Ihr Account wurde gesperrt, verwenden Sie bitte die Funktion „Zugangsdaten vergessen?“.'],
        },
        '_429': {
            headline: 'Zu viele Anfragen.',
            details: ['Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'],
        },
        '_504': {
            headline: this.messages.fehlerAufgetreten,
            details: ['Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'],
        },
        '_0': {
            headline: 'Unbekannter Fehler.',
            details: ['Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'],
        },
    };

    /* Timeout für Redirect zum Login-Screen Timeout for redirect to login screen after token expired */
    readonly tokenExpRedirectTimeout: number = 3000;

    readonly jsonBusinessFiles = {
        kreditliniePremium: 'kreditliniePremium',
        kreditlinieSpezial: 'kreditlinieSpezial',
        produktlinieRahmenvertrag: 'produktlinieRahmenvertrag',
        produktlinieVhvKaution: 'produktlinieVhvKaution',
        laender: 'laender'
    };

    /* Rest service paths */
    readonly restParentPath: string = '/api';

}
